import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@dev-go4ellis/go4-design-system';
import './FooterCTA.scss';

const FOOTER_COLS = [
  {
    title: 'For organizers',
    links: [
      { label: 'Post a job', href: '#pricing' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'How it works', href: '#how' },
      { label: 'Coverage & compliance', href: '#trust' },
    ],
  },
  {
    title: 'For trainers',
    links: [
      { label: 'Find work', href: '#' },
      { label: 'Get credentialed', href: '#' },
      { label: 'Payments', href: '#' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '#' },
      { label: 'Contact', href: '#' },
      { label: 'Terms', href: '#' },
      { label: 'Privacy', href: '#' },
    ],
  },
];

const ArrowRight = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 8 }}><path d="M5 12h14M12 5l7 7-7 7" /></svg>
);

const FooterCTA = ({ onPostJob, onReRun }) => (
  <React.Fragment>
    <section className="pl-cta">
      <div className="pl-cta__inner">
        <h2 className="pl-cta__title">You've seen the number. Now fill the shift.</h2>
        <p className="pl-cta__lead">Posting is free and takes a few minutes. Trainers in your area see it immediately.</p>
        <div className="pl-cta__actions">
          <Button variant="primary" size="lg" onClick={onPostJob}>Post a job free<ArrowRight /></Button>
          <Button variant="secondary" size="lg" onClick={onReRun}>Re-run my estimate</Button>
        </div>
      </div>
    </section>

    <footer className="pl-footer">
      <div className="pl-footer__inner">
        <div className="pl-footer__top">
          <div>
            <div className="pl-footer__logo">Go<span>4</span></div>
            <p className="pl-footer__blurb">On-demand athletic trainer coverage for events, schools and organizations nationwide.</p>
          </div>
          {FOOTER_COLS.map((col) => (
            <div key={col.title} className="pl-footer__col">
              <div className="pl-footer__col-title">{col.title}</div>
              <div className="pl-footer__links">
                {col.links.map((link) => (
                  <a key={link.label} href={link.href} className="pl-footer__link">{link.label}</a>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="pl-footer__bottom">
          <div className="pl-footer__note">© 2026 Go4. All rights reserved.</div>
          <div className="pl-footer__note">Service fee shown is 17.5% of trainer pay. Rates shown are historical averages, not quotes.</div>
        </div>
      </div>
    </footer>
  </React.Fragment>
);

FooterCTA.propTypes = {
  onPostJob: PropTypes.func,
  onReRun: PropTypes.func,
};

FooterCTA.defaultProps = {
  onPostJob: () => {},
  onReRun: () => {},
};

export default FooterCTA;
